import type { PickPartial } from '@pushflow/types'
import { Range as ReactRange } from 'react-range'
import type { IProps } from 'react-range/lib/types'

export const Range = <GValues extends [number] | [number, number]>(
  props: Omit<
    PickPartial<
      IProps,
      | 'label'
      | 'labelledBy'
      | 'direction'
      | 'allowOverlap'
      | 'draggableTrack'
      | 'rtl'
      | 'step'
      | 'disabled'
    >,
    'values' | 'onChange'
  > & {
    values: GValues
    onChange: (values: GValues) => void
  },
) => {
  const clampedValues = props.values.map((value) =>
    Math.min(Math.max(value, props.min), props.max),
  ) as GValues

  const handleChange = (newValues: number[]) => {
    const clampedNewValues = newValues.map((value) =>
      Math.min(Math.max(value, props.min), props.max),
    )
    props.onChange(clampedNewValues as GValues)
  }

  return (
    <ReactRange
      {...props}
      values={clampedValues}
      onChange={handleChange}
    />
  )
}
